import { Table, TableProps } from 'antd';
import { formatCurrency, formatNumber } from '../../../../../common/utils';
import { SexuallyInappropriateAnalysesData } from '../SexuallyInappropriateAnalyses';

const CostTokenDetails: React.FC<{
  selectSexuallyInappropriateData:
    | SexuallyInappropriateAnalysesData
    | undefined;
}> = ({ selectSexuallyInappropriateData }) => {
  const columns: TableProps<SexuallyInappropriateAnalysesData>['columns'] = [
    {
      title: 'Input Price',
      dataIndex: 'inputPrice',
      key: 'inputPrice',
      width: 100,
      render: (value) => formatCurrency({ value: value ?? 0 }),
    },
    {
      title: 'Output Price',
      dataIndex: 'outputPrice',
      key: 'outputPrice',
      width: 100,
      render: (value) => formatCurrency({ value: value ?? 0 }),
    },
    {
      title: 'Total Price',
      dataIndex: 'totalPrice',
      key: 'totalPrice',
      width: 100,
      render: (value) => formatCurrency({ value: value ?? 0 }),
    },

    {
      title: 'Input Tokens',
      dataIndex: 'inputTokens',
      key: 'inputTokens',
      width: 100,
      render: (value: string) => formatNumber(+(value ?? 0)),
    },
    {
      title: 'Output Tokens',
      dataIndex: 'outputTokens',
      key: 'outputTokens',
      width: 100,
      render: (value: string) => formatNumber(+(value ?? 0)),
    },
    {
      title: 'Total Tokens',
      dataIndex: 'totalTokens',
      key: 'totalTokens',
      width: 100,
      render: (value: string) => formatNumber(+(value ?? 0)),
    },
  ];

  const dataSource: SexuallyInappropriateAnalysesData[] = [
    {
      ...selectSexuallyInappropriateData,
      documentId: selectSexuallyInappropriateData?.documentId ?? '',
    },
  ];

  return (
    <div>
      <div className="d-flex mt-16 full-width">
        <Table<SexuallyInappropriateAnalysesData>
          columns={columns}
          dataSource={dataSource}
          pagination={false}
          scroll={{
            x: 'max-content',
          }}
        />
      </div>{' '}
    </div>
  );
};

export default CostTokenDetails;
